




























import { Vat, VatState } from '@/api';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VatModals } from './models/vat-modals';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: { SaveCancelButtons },
})
export default class EditVatStateModal extends Vue {
	@Prop({ required: true, type: Object })
	public vat!: Vat;

	@Prop({ required: true, type: Function })
	public onVatStateChanged!: (vat: Vat) => Promise<void>;

	public get vatStates() {
		return [
			{ value: VatState.Supply, text: 'Currently Supplying' },
			{ value: VatState.NonSupply, text: 'Non-supply' },
			{ value: VatState.NotUsed, text: 'Not In Use' },
		];
	}

	public modalId: string = VatModals.STATE;
	public state: VatState = this.vat.state ?? VatState.Supply;

	public async submit(): Promise<void> {
		this.vat.state = this.state;
		await this.onVatStateChanged(this.vat);
		this.dismiss();
	}

	public dismiss(): void {
		this.$bvModal.hide(VatModals.STATE);
	}
}
